const e = {
  locale: "en",
  formPasswordField: {
    minDigits: "At least 1 digit (0-9)",
    minLength: "8 or more characters",
    minLowerCase: "At least 1 lowercase character (a-z)",
    minUpperCase: "At least 1 UPPERCASE character (A-Z)"
  },
  formCurrencySelectField: {
    currencyOfAccount: "Currency of account",
    invoiceCurrency: "Invoice currency"
  },
  sharePSPButton: {
    copyLink: "Copy Link"
  },
  uploadFile: {
    placeholder: "Click to attach or drag and drop the file",
    placeholderMobile: "Click to attach the file",
    fileTypeError: "Invalid file format"
  },
  dropzone: {
    placeholder: "Upload a file or drag and drop",
    defaultErrorMessage: "Upload failed"
  }
}, r = e;
export {
  r as default
};
//# sourceMappingURL=en.mjs.map
